/**
 * profile-menu.js - Profile menu.
 *
 * This is used to implement profile menu that consists of the user's name and
 * a user photo. When clicked, it will display a drop-down menu offering
 * additional services related to the user.
 *
 * @author Alex Symeonidis
 */
import React, { Component } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";

function MenuItem(props) {
  let history = useHistory();

  function handleClick(event) {
    event.preventDefault();
    history.push(props.toUrl);
  }

  return <Link className="dropdown-item" to={props.toUrl} onClick={handleClick}>
    {
      props.icon !== undefined &&
      <i className={'fas ' + props.icon + ' fa-sm fa-fw mr-2 text-gray-400'}/>
    }
    {props.title}
  </Link>
}

function MenuDivider() {
  return <div className="dropdown-divider"/>;
}

class ProfileMenu extends Component {
  render() {

    return (
      <li className="nav-item dropdown no-arrow">
        <Link className="nav-link dropdown-toggle" to="/profile" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span className="mr-2 d-none d-lg-inline text-gray-600 small">{this.props.profile.identity.firstName + ' ' + this.props.profile.identity.lastName}</span>
          <img className="img-profile rounded-circle" src="https://source.unsplash.com/QAB-WJcbgJk/60x60" alt={""}/>
        </Link>

        {/* Dropdown - User Information */}
        <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
          <MenuItem title={'Profile'} toUrl='/profile' icon={'fa-user'}/>
          <MenuDivider/>
          <MenuItem title={'Logout'} toUrl='/logout' icon={'fa-sign-out-alt'}/>
        </div>

      </li>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default withRouter(connect(mapStateToProps)(ProfileMenu))